/* Cloofs – Sliders ook met de muis bedienen.
   1. De dunne voortgangslijn onder een slider is een schuifbalk: aanklikken of slepen.
   2. Met de muis kun je de slider zelf vastpakken en slepen (touch scrolt al vanzelf).
   3. Hero-slider (Impulse slideshow met automatisch doorschuiven): na aanraken of swipen meteen weer doorschuiven,
      gelijk met het balkje onder de foto.
   Geldt voor alle cloofs-sliders: een .cloofs-progress / .cloofs-cart__progress direct na de track
   ([data-track], [data-cloofs-slider], [data-recs-track]). Na het loslaten klikt een kaart niet per ongeluk door.
   Geladen in snippets/cloofs-layout (defer). Geen afhankelijkheden. */
(() => {
  if (window.cloofsSliderLoaded) return;
  window.cloofsSliderLoaded = true;

  const TRACKS = '[data-track], [data-cloofs-slider], [data-recs-track]';
  const BARS = '.cloofs-progress, .cloofs-cart__progress';
  const free = (track, on) => {
    track.style.scrollSnapType = on ? 'none' : '';
    track.style.scrollBehavior = on ? 'auto' : '';
  };
  const scrollable = (track) => track && track.matches && track.matches(TRACKS) && track.scrollWidth > track.clientWidth + 1;

  /* 1. Voortgangslijn als schuifbalk */
  document.addEventListener('pointerdown', (e) => {
    const bar = e.target.closest && e.target.closest(BARS);
    if (!bar) return;
    const track = bar.previousElementSibling;
    if (!scrollable(track)) return;
    e.preventDefault();
    const rect = bar.getBoundingClientRect();
    const thumb = bar.querySelector('span');
    const t = thumb ? thumb.getBoundingClientRect() : { left: 0, right: 0, width: 0 };
    const grab = e.clientX >= t.left && e.clientX <= t.right ? e.clientX - t.left : t.width / 2;
    const max = track.scrollWidth - track.clientWidth;
    const move = (ev) => {
      const ratio = (ev.clientX - rect.left - grab) / Math.max(1, rect.width - t.width);
      track.scrollLeft = Math.max(0, Math.min(1, ratio)) * max;
    };
    const up = () => {
      bar.removeEventListener('pointermove', move);
      bar.removeEventListener('pointerup', up);
      bar.removeEventListener('pointercancel', up);
      bar.classList.remove('is-dragging');
      free(track, false);
    };
    free(track, true);
    bar.classList.add('is-dragging');
    try { bar.setPointerCapture(e.pointerId); } catch (err) { /* oude browser */ }
    bar.addEventListener('pointermove', move);
    bar.addEventListener('pointerup', up);
    bar.addEventListener('pointercancel', up);
    move(e);
  });

  /* 2. Slider slepen met de muis */
  let drag = null;
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0 || !e.target.closest) return;
    const track = e.target.closest(TRACKS);
    if (!scrollable(track) || e.target.closest('button, input, select, textarea, label, [data-rc-sizes]')) return;
    drag = { track, x: e.clientX, left: track.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 6) return;
      drag.moved = true;
      free(drag.track, true);
      drag.track.classList.add('is-dragging');
    }
    drag.track.scrollLeft = drag.left - dx;
  });
  const end = () => {
    if (!drag) return;
    const d = drag;
    drag = null;
    if (!d.moved) return;
    d.track.classList.remove('is-dragging');
    free(d.track, false);
    const stop = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
    d.track.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(() => d.track.removeEventListener('click', stop, { capture: true }), 60);
  };
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  document.addEventListener('dragstart', (e) => {
    if (e.target.closest && e.target.closest(TRACKS)) e.preventDefault();
  });

  /* 3. Hero-slider blijft automatisch doorschuiven na aanraken of swipen.
     Flickity stopt het doorschuiven bij elke aanraking (op mobiel al bij het begin van scrollen).
     Bij loslaten starten we het meteen opnieuw en laten we het balkje onder de foto op hetzelfde moment
     opnieuw vollopen, zodat de wissel precies gebeurt als het balkje vol is.
     Flickity gebruikt op telefoons touch-events, daarom luisteren we naar touch- én pointer-events,
     plus Flickity's eigen 'settle' als vangnet. */
  const restartBar = (hero) => {
    const dot = hero.querySelector('.flickity-page-dots .dot.is-selected');
    if (!dot) return;
    dot.classList.remove('is-selected');
    void dot.offsetWidth; // herstart de CSS-animatie
    dot.classList.add('is-selected');
  };
  const resumeHero = (hero) => {
    if (!hero || hero.dataset.autoplay !== 'true' || !window.Flickity) return;
    const flkty = window.Flickity.data(hero);
    if (!flkty || !flkty.player) return;
    if (!hero.cloofsResumeBound) {
      hero.cloofsResumeBound = true;
      flkty.on('settle', () => { if (flkty.player.state === 'stopped') resumeHero(hero); });
    }
    clearTimeout(hero.cloofsResume);
    hero.cloofsResume = setTimeout(() => {
      if (flkty.player.state === 'playing') return;
      flkty.playPlayer();
      restartBar(hero);
    }, 0);
  };
  ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach((type) => {
    document.addEventListener(type, (e) => {
      resumeHero(e.target.closest && e.target.closest('.hero[data-autoplay="true"]'));
    }, { passive: true });
  });
})();
